import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c9b41f70&"
import script from "./App.vue?vue&type=script&setup=true&lang=ts&"
export * from "./App.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports